export const UPSELL_CAMPAIGN = {
  title: 'A HALLOWEEN TREAT',
  titleMobile: 'HALLOWEEN TREAT',
  promoCode: 'BOOOO',
  analyticsName: 'halloween_upsell',
} as const
